import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';


const CRP_COMMUNICATIONS_BASE_URL = process.env.REACT_APP_CRP_BASE_URL

export const crpCommunicationsCuratedBaseApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: CRP_COMMUNICATIONS_BASE_URL }),
    endpoints: () => ({}),
    reducerPath: CRP_COMMUNICATIONS_BASE_URL
})